import { Reveal } from "./Reveal";

export const Panel = ({ label, children, tint = false, className = "", id }) => (
  <section id={id} className={`panel ${tint ? "panel-tint" : ""} px-6 py-12 sm:px-10 sm:py-14 lg:px-14 ${className}`}>
    {label && <span className="pill">{label}</span>}
    {children}
  </section>
);

export const PageHead = ({ label, title, intro, testId }) => (
  <Reveal>
    <section data-testid={testId} className="panel mt-[108px] px-6 py-14 sm:px-12 lg:px-16">
      <span className="pill">{label}</span>
      <h1 className="h1 max-w-3xl">{title}</h1>
      {intro && <p className="lead mt-5 max-w-2xl">{intro}</p>}
    </section>
  </Reveal>
);
